import {useState} from 'react';
import {getConsent, setConsent, enableAnalytics} from '../../utils/consent';

// Cookie consent banner (152-ФЗ ст. 9). Trackers stay off until the visitor
// makes an explicit choice. "Принять" enables analytics; "Отклонить" keeps
// only the essential cookies the site needs to function.
export default function CookieConsent() {
    const [visible, setVisible] = useState(() => !getConsent());

    if (!visible) return null;

    const accept = () => {
        setConsent('accepted');
        enableAnalytics();
        setVisible(false);
    };

    const decline = () => {
        setConsent('rejected');
        setVisible(false);
    };

    return (
        <div
            role="dialog"
            aria-live="polite"
            aria-label="Уведомление об использовании файлов cookie"
            className="fixed inset-x-0 bottom-0 z-[70] p-3 sm:p-4"
        >
            <div
                className="mx-auto max-w-[1110px] rounded-2xl bg-white shadow-2xl border border-brand-dark/10 p-4 sm:p-5 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <p className="text-sm text-brand-dark/80 leading-relaxed">
                    Мы используем файлы cookie и сервис веб-аналитики Яндекс.Метрика, чтобы сайт работал
                    корректно и удобно. Аналитика включается только с вашего согласия. Подробнее — в{' '}
                    <a href="/privacy-policy.html"
                       className="text-brand-red underline hover:opacity-80">
                        Политике обработки персональных данных
                    </a>.
                </p>
                <div className="flex flex-shrink-0 gap-3">
                    <button
                        type="button"
                        onClick={decline}
                        className="flex-1 md:flex-none px-5 py-2.5 rounded-xl bg-brand-gray text-brand-dark text-sm font-medium hover:bg-gray-200 transition whitespace-nowrap"
                    >
                        Отклонить
                    </button>
                    <button
                        type="button"
                        onClick={accept}
                        className="flex-1 md:flex-none px-5 py-2.5 rounded-xl bg-gradient-to-r from-brand-red via-brand-pink to-brand-orange text-white text-sm font-semibold hover:opacity-95 transition whitespace-nowrap"
                    >
                        Принять
                    </button>
                </div>
            </div>
        </div>
    );
}
